module.exports = __webpack_public_path__ + "img/VUSE_GO_Logo_Blanco.c40ebd20.png";